import {
  FETCH_LOYALTY_CONFIG_REQUEST,
  FETCH_LOYALTY_CONFIG_SUCCESS,
  FETCH_LOYALTY_CONFIG_FAILURE,
  CREATE_LOYALTY_CONFIG_REQUEST,
  CREATE_LOYALTY_CONFIG_SUCCESS,
  CREATE_LOYALTY_CONFIG_FAILURE,
  UPDATE_LOYALTY_CONFIG_REQUEST,
  UPDATE_LOYALTY_CONFIG_SUCCESS,
  UPDATE_LOYALTY_CONFIG_FAILURE,
  DELETE_LOYALTY_CONFIG_REQUEST,
  DELETE_LOYALTY_CONFIG_SUCCESS,
  DELETE_LOYALTY_CONFIG_FAILURE,
} from "./types";

import {
  fetchLoyaltyConfig,
  createLoyaltyConfig,
  updateLoyaltyConfig,
  deleteLoyaltyConfig,
} from "../../services/loyaltyConfigService";


export const fetchLoyaltyConfigAction = () => async (dispatch) => {
  dispatch({ type: FETCH_LOYALTY_CONFIG_REQUEST });

  try {
    const response = await fetchLoyaltyConfig();

    if (response.success) {
      dispatch({
        type: FETCH_LOYALTY_CONFIG_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_LOYALTY_CONFIG_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_LOYALTY_CONFIG_FAILURE,
      payload: error.message,
    });
  }
};


export const createLoyaltyConfigAction = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_LOYALTY_CONFIG_REQUEST });

  try {
    const response = await createLoyaltyConfig(payload);

    if (response.success) {
      dispatch({
        type: CREATE_LOYALTY_CONFIG_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: CREATE_LOYALTY_CONFIG_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_LOYALTY_CONFIG_FAILURE,
      payload: error.message,
    });
  }
};


export const updateLoyaltyConfigAction = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_LOYALTY_CONFIG_REQUEST });

  try {
    const response = await updateLoyaltyConfig(payload);

    if (response.success) {
      dispatch({
        type: UPDATE_LOYALTY_CONFIG_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: UPDATE_LOYALTY_CONFIG_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_LOYALTY_CONFIG_FAILURE,
      payload: error.message,
    });
  }
};


export const deleteLoyaltyConfigAction = () => async (dispatch) => {
  dispatch({ type: DELETE_LOYALTY_CONFIG_REQUEST });

  try {
    const response = await deleteLoyaltyConfig();

    if (response.success) {
      dispatch({ type: DELETE_LOYALTY_CONFIG_SUCCESS });
    } else {
      dispatch({
        type: DELETE_LOYALTY_CONFIG_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: DELETE_LOYALTY_CONFIG_FAILURE,
      payload: error.message,
    });
  }
};